import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feffefa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-camera fs-5x",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_camera = _resolveComponent("camera", true)!

  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "d-flex flex-column VZ_TABLE_BUTTON selectedControled" }, _ctx.dynamicAttrs), [
    (_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_camera, {
            ref: "cameraRef",
            resolution: { width: 150, height: 150 },
            autoplay: ""
          }, null, 512),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.snapshot && _ctx.snapshot(...args))),
            class: "btn btn-outline btn-outline-primary btn-active-light-primary"
          }, " Take photo ")
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4)),
    _withDirectives(_createElementVNode("img", {
      src: _ctx.imageSrc,
      class: "img-fluid mt-1"
    }, null, 8, _hoisted_5), [
      [_vShow, _ctx.imageSrc]
    ])
  ], 16))
}